// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iCY_","input":"styles_input__9K4zM"};